import paginatedStore from '../lib/paginatedStore'
export default paginatedStore('/campaigns/active/leaderboard', err =>
	err.name === 'APIError' && err.status === 403
		? 'Sorry, no leaderboard is currently available for this campaign.'
		: 'Failed to fetch the leaderboard.'
)
